import React, { useEffect, useState } from "react";
import { Card, Col, Row } from "react-bootstrap";

const GeneralFields = ({ fields, setFields }) => {
  const generalFields = fields.filter((field) => field.role === "");
  const [included, setIncluded] = useState({
    structure: false,
    roof: false,
    mAndE: false,
    externals: false,
  });

  useEffect(() => {
    setIncluded({
      structure:
        fields.filter(
          (field) => field?.name?.includes("structure") && field.isIncluded
        ).length > 0,
      roof:
        fields.filter(
          (field) => field?.name?.includes("roof") && field.isIncluded
        ).length > 0,
      mAndE:
        fields.filter(
          (field) => field?.name?.includes("mAndE") && field.isIncluded
        ).length > 0,
      externals:
        fields.filter(
          (field) => field?.name?.includes("externals") && field.isIncluded
        ).length > 0,
    });
  }, [fields]);

  const handleChange = (e) => {
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp.id === e.id) {
          temp.isIncluded = !temp.isIncluded;
        }
        return temp;
      })
    );
  };

  const handleStructureFields = () => {
    setIncluded({ ...included, structure: !included.structure });
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp?.name?.includes("structure")) {
          temp.isIncluded = !included.structure;
        }
        return temp;
      })
    );
  };
  const handleRoofFields = () => {
    setIncluded({ ...included, roof: !included.roof });
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp?.name?.includes("roof")) {
          temp.isIncluded = !included.roof;
        }
        return temp;
      })
    );
  };
  const handleMAndE = () => {
    setIncluded({ ...included, mAndE: !included.mAndE });
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp?.name?.includes("mAndE")) {
          temp.isIncluded = !included.mAndE;
        }
        return temp;
      })
    );
  };
  const handleExternals = () => {
    setIncluded({ ...included, externals: !included.externals });
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp?.name?.includes("externals")) {
          temp.isIncluded = !included.externals;
        }
        return temp;
      })
    );
  };

  return (
    <>
      <Card className="mt-4">
        <Card.Body className="px-4">
          <Row className="align-items-center">
            <Col lg="4">
              <div className="mb-3">
                <input
                  type="checkbox"
                  className="checkbox-style"
                  checked={included.structure}
                  onChange={() => handleStructureFields()}
                  id="structure-1"
                  name="structure"
                />
                <label htmlFor="structure-1" className="align-items-center">
                  <div className="media-body">
                    <h4>Structure</h4> <p>Click will enable the rest fields</p>
                  </div>
                </label>
              </div>
            </Col>
            <Col lg="8">
              <Row>
                {generalFields
                  .filter((item) => item.name.includes("structure"))
                  .map((gField) => (
                    <Col lg="4" key={gField.id}>
                      <div className="mb-3">
                        <input
                          type="checkbox"
                          className="checkbox-style"
                          disabled={!included.structure}
                          checked={gField.isIncluded}
                          onChange={() => handleChange(gField)}
                          id={gField.id}
                          name="structure"
                        />
                        <label htmlFor={gField.id}>
                          <span>{gField.title}</span>
                        </label>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Body className="px-4">
          <Row className="align-items-center">
            <Col lg="4">
              <div className="mb-3">
                <input
                  type="checkbox"
                  className="checkbox-style"
                  checked={included.roof}
                  onChange={() => handleRoofFields()}
                  id="Roof-1"
                  name="Roof"
                />
                <label htmlFor="Roof-1" className="align-items-center">
                  <div className="media-body">
                    <h4>Roof</h4> <p>Click will enable the rest fields</p>
                  </div>
                </label>
              </div>
            </Col>
            <Col lg="8">
              <Row>
                {generalFields
                  .filter((item) => item.name.includes("roof"))
                  .map((gField) => (
                    <Col lg="4" key={gField.id}>
                      <div className="mb-3">
                        <input
                          type="checkbox"
                          className="checkbox-style"
                          disabled={!included.roof}
                          checked={gField.isIncluded}
                          onChange={() => handleChange(gField)}
                          id={gField.id}
                          name="structure"
                        />
                        <label htmlFor={gField.id}>
                          <span>{gField.title}</span>
                        </label>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Body className="px-4">
          <Row className="align-items-center">
            <Col lg="4">
              <div className="mb-3">
                <input
                  type="checkbox"
                  className="checkbox-style"
                  checked={included.mAndE}
                  onChange={() => handleMAndE()}
                  id="me-1"
                  name="me"
                />
                <label htmlFor="me-1" className="align-items-center">
                  <div className="media-body">
                    <h4>M&E</h4> <p>Click will enable the rest fields</p>
                  </div>
                </label>
              </div>
            </Col>
            <Col lg="8">
              <Row>
                {generalFields
                  .filter((item) => item.name.includes("mAndE"))
                  .map((gField) => (
                    <Col lg="4" key={gField.id}>
                      <div className="mb-3">
                        <input
                          type="checkbox"
                          className="checkbox-style"
                          disabled={!included.mAndE}
                          checked={gField.isIncluded}
                          onChange={() => handleChange(gField)}
                          id={gField.id}
                          name="structure"
                        />
                        <label htmlFor={gField.id}>
                          <span>{gField.title}</span>
                        </label>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mt-4">
        <Card.Body className="px-4">
          <Row className="align-items-center">
            <Col lg="4">
              <div className="mb-3">
                <input
                  type="checkbox"
                  className="checkbox-style"
                  checked={included.externals}
                  onChange={() => handleExternals()}
                  id="externals-1"
                  name="externals"
                />
                <label htmlFor="externals-1" className="align-items-center">
                  <div className="media-body">
                    <h4>Externals</h4> <p>Click will enable the rest fields</p>
                  </div>
                </label>
              </div>
            </Col>
            <Col lg="8">
              <Row>
                {generalFields
                  .filter((item) => item.name.includes("externals"))
                  .map((gField) => (
                    <Col lg="4" key={gField.id}>
                      <div className="mb-3">
                        <input
                          type="checkbox"
                          className="checkbox-style"
                          disabled={!included.externals}
                          checked={gField.isIncluded}
                          onChange={() => handleChange(gField)}
                          id={gField.id}
                          name="structure"
                        />
                        <label htmlFor={gField.id}>
                          <span>{gField.title}</span>
                        </label>
                      </div>
                    </Col>
                  ))}
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default GeneralFields;
